import simulationDataDefaultValues
  from '@/domain/enums/installation/engineering/loadSimulation/loadSimulationDefaultValues';
import * as Mutations from '../../mutations';

export default {
  setInstallation({ commit }, installation) {
    commit(Mutations.SET_INSTALLATION, installation);
  },
  setUserAccessibleInstallations({ commit }, installations) {
    commit(Mutations.SET_USER_ACCESSIBLE_INSTALLATION, installations);
  },
  setSimulationDataPoints({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_POINTS, data);
  },
  setSimulationDataIsInvalid({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_IS_INVALID, data);
  },
  setSimulationDataValidPoints({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_VALID_POINTS, data);
  },
  setSimulationDataIsEmpty({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_IS_EMPTY, data);
  },
  setSimulationDataInterval({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_INTERVAL, data);
  },
  setSimulationDataIsIntervalInvalid({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_IS_INTERVAL_INVALID, data);
  },
  setSimulationDataRepetitions({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_REPETITIONS, data);
  },
  setSimulationDataIsRepetitionsInvalid({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_IS_REPETITIONS_INVALID, data);
  },
  setSimulationDataImportData({ commit }, data) {
    commit(Mutations.SET_SIMULATION_DATA_IMPORT_DATA, data);
  },
  setSimulationDataReset({ commit }) {
    commit(Mutations.SET_SIMULATION_DATA_POINTS, []);
    commit(Mutations.SET_SIMULATION_DATA_IS_INVALID, true);
    commit(Mutations.SET_SIMULATION_DATA_VALID_POINTS, []);
    commit(Mutations.SET_SIMULATION_DATA_IS_EMPTY, true);
    commit(
      Mutations.SET_SIMULATION_DATA_INTERVAL,
      simulationDataDefaultValues.TIME_INTERVAL_BETWEEN_POINTS,
    );
    commit(Mutations.SET_SIMULATION_DATA_IS_INTERVAL_INVALID, false);
    commit(
      Mutations.SET_SIMULATION_DATA_REPETITIONS,
      simulationDataDefaultValues.SIMULATION_REPETITIONS_NUMBER,
    );
    commit(Mutations.SET_SIMULATION_DATA_IS_REPETITIONS_INVALID, false);
    commit(Mutations.SET_SIMULATION_DATA_IMPORT_DATA, {});
  },
};
